import React from "react";

//importing styled components
import { Container, From, On, Slash } from "components/route_path/style";

//importing Link
import { Link } from "react-router-dom";

const RoutePath = ({ path, from, on }) => {
 return (
  <Container>
   <Link to={path}>
    <From>{from}</From>
   </Link>
   <Slash> &nbsp; &nbsp; /  &nbsp; &nbsp;</Slash>
   <On>{on}</On>
  </Container>
 );
};

export default RoutePath;
